import { AbstractControl, ValidationErrors } from '@angular/forms';

export function passwordMatchValidator(passwordControlName: string, confirmPasswordControl: AbstractControl): ValidationErrors | null {
    // Note: On initial form load the form group (parent) will be null.
    if(confirmPasswordControl.parent === null) {
        return null;
    }

    const password = confirmPasswordControl.parent.controls[passwordControlName].value;
    const confirmPassword = confirmPasswordControl.value;

    if (confirmPassword !== undefined && 
        confirmPassword !== null && 
        confirmPassword !== '' && 
        password !== confirmPassword
    ) {
        return { passwordMismatch: true };
    }

    // This means the form validation passed
    return null;
}